import { Redirect, Route, Switch } from 'react-router-dom';
import { useReducer, useEffect } from 'react';
import MockupRoutes from './MockupRoutes';
import PublicRoute from './publicRoute';
import { AuthReducer, initialStateAuth } from '../Context/reducer/authReducer';
import { AuthStateContext } from '../Context';
import ForgotPassword from '../Containers/views/ForgotPassword/index';
import PortalLogin from '../Containers/views/PortalLogin';
import ssoAuth from '../Containers/views/sso';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const Routes = () => {
    const [authUser, authDispatch] = useReducer(AuthReducer, initialStateAuth);
    const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : '';
    const history = useHistory();

    useEffect(() => {
        const pathname = window.location.pathname;

        // Block script if URL contains '/sso'
        if (pathname.includes('/sso')) return;

        if (!localStorage.getItem('user')) {
            localStorage.clear();
            history.replace('/login');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    return (
        <Switch>
            <AuthStateContext.Provider value={{ authUser, authDispatch }}>
                <Route path="/driver/:path?/:id?">
                    <MockupRoutes />
                </Route>
                <Route path="/:id?" exact>
                    <PublicRoute path="/login" exact component={PortalLogin} />
                    <PublicRoute path="/sso" exact component={ssoAuth} />
                    <PublicRoute path="/forgot-password" exact component={ForgotPassword} />
                    <PublicRoute path="/" exact component={() => <Redirect to="/login" />} />
                </Route>
            </AuthStateContext.Provider>
        </Switch>
    );
};

export default Routes;
